import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { saveCustomer } from "../../actions/CustomerActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import { saveDriver } from '../../../src/actions/DriverActions';
import Mobilemenu from "../../layouts/mobile-menu";

function AddDriver() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [phone, setPhone] = useState('');
    const [eida, setEida] = useState('');
    const [fax, setFax] = useState('');
    const [address, setAddress] = useState('');
    const loading = useSelector(state => state?.loading?.loading);

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else if (eida.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'EIDA is Required!'
            })
        } else if (address.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Address is Required!'
            })
        } else if (mobile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Mobile No. is Required!'
            })
        }
        else {
            let data = {
                name: name,
                email: email,
                phone: phone,
                eida: eida,
                mobile_no: mobile,
                fax: fax,
                address: address,
            }
            dispatch(saveDriver(data, navigate));
        }
        // window.location.href = ('/state');
    }

    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);

        // Validate the email format
        const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
        setIsEmailValid(isValidEmail);
    };

    const [isNameValid, setIsNameValid] = useState(true);

    const handleChangeName = (e) => {
        setName(e.target.value);

        // Validate the name format (no numbers allowed)
        const isValidName = /^[a-zA-Z\s]*$/.test(e.target.value);
        setIsNameValid(isValidName);
    };

    const [isMobileValid, setIsMobileValid] = useState(true);

    const handleChangeMobile = (e) => {
        
        setMobile(e.target.value);

        // Validate the phone number format
        const isMobileValid = /^[0-9]*$/.test(e.target.value);
        setIsMobileValid(isMobileValid);
    };

    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const handleChangePhone = (e) => {
        setPhone(e.target.value);

        // Validate the phone number format
        const isValidPhone = /^[0-9]*$/.test(e.target.value);
        setIsPhoneValid(isValidPhone);
    };

    const [files, setFiles] = useState([]);
    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: '.jpeg,.png,.jpg',
        maxFiles: 30,
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (files.length < 1) {
                setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30) {
                    Toast.fire({
                        imageUrl: '/images/icons/cross.jpg',
                        imageHeight: 70,
                        title: 'Maximum 30 Images Allowed',
                        confirmButtonColor: "#1ed0b1"
                    });
                } else {
                    setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    imageUrl: '/images/icons/cross.jpg',
                    imageHeight: 70,
                    title: error,
                    confirmButtonColor: "#1ed0b1"
                });
            }
        }
    });
    const removeImage = (file, index) => {
        setFiles(files.filter((allFiles, i) => i !== index).map((file, index) => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
        if (index == 0 && file.default == 1) {
            files[1].default = 1;
        } else if (index != 0 && file.default == 1) {
            files[0].default = 1;
        }
    }
    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");
    const thumbs = files.map((file, index) => {
        return (
            <React.Fragment key={file.id}>
                <div>
                    <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                        <div style={thumbInner}>
                            <img
                                src={file.preview}
                                style={img}
                            />
                        </div>
                    </div>
                    <span class="image-close" onClick={() => removeImage(file, index)}>&times;</span>
                </div>
            </React.Fragment>
        )
    }
    );
    return (
        <React.Fragment>
             <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Add Driver
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name <span className="text-theme-6">*</span> :</label>
                                        <input id="name" name="name" value={name} onChange={(e) => handleChangeName(e)} type="text" className={`form-control ${isNameValid ? '' : 'is-invalid'}`} placeholder="Enter Name" />
                                        {isNameValid == false && <div className="invalid-feedback">Please enter a valid name without numbers.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="cnic" className="form-label">EIDA <span className="text-theme-6">*</span> :</label>
                                        <input id="cnic" name="cnic" type="text" onChange={(e) => setEida(e.target.value)} className="form-control" placeholder="Enter EIDA" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Email :</label>
                                        <input id="email" name="email" type="text" value={email} onChange={(e) => handleChangeEmail(e)} className={`form-control ${isEmailValid ? '' : 'is-invalid'}`} placeholder="Enter Email" />
                                        {!isEmailValid && <div className="invalid-feedback">Please enter a valid email address.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Mobile <span className="text-theme-6">*</span> :</label>
                                        <input id="mobile" name="mobile" type="text" value={mobile} onChange={(e) => handleChangeMobile(e)} className={`form-control ${isMobileValid ? '' : 'is-invalid'}`} placeholder="Enter Mobile No." />
                                        {!isMobileValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="phone" className="form-label">Phone :</label>
                                        <input id="phone" name="phone" type="text" value={phone} onChange={(e) => handleChangePhone(e)} className={`form-control ${isPhoneValid ? '' : 'is-invalid'}`} placeholder="Enter Phone No." />
                                        {!isPhoneValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="fax" className="form-label">FAX :</label>
                                        <input id="fax" name="fax" type="text" onChange={(e) => setFax(e.target.value)} className="form-control" placeholder="Enter FAX" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="address" className="form-label">Address <span className="text-theme-6">*</span> :</label>
                                        <input id="address" name="address" type="text" onChange={(e) => setAddress(e.target.value)} className="form-control" placeholder="Enter Address" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="image" className="form-label">Image:</label>
                                        <section className="container text-center form-control">
                                            <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                {
                                                    (files.length == 0) &&
                                                    <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                }
                                                {thumbs}
                                            </aside>
                                            <div {...getRootProps({ className: 'dropzone' })}>
                                                <input {...getInputProps()} />
                                                <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                <p className="text-gray-500 mt-1">or Drag Them</p>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/drivers')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                     <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddDriver;